export const API_UNAVAILABLE_EVENT = 'akive:api-unavailable'
export const CORE_LEGAL_REQUIREMENT_EVENT = 'akive:core-legal-requirement'
export const AI_LEGAL_REQUIREMENT_EVENT = 'akive:ai-legal-requirement'
